import { Component, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage';
import { NavController, ToastController, ModalController, AlertController } from '@ionic/angular';
import { NavigationExtras, Router } from '@angular/router';
import { UtilService } from '../../service/util.service';
import { UserProfile } from '../../models/user-profile.model';
import { UserData } from '../../providers/user-data';
import { ProductRequestComponent } from '../../component/advanced-filter/product-request/product-request.component';
import { ProductRequestService } from './product-request.service';
import { ProductRequestStatus } from '../../enum/ProductRequestStatus';
import { RoleAccess } from '../../models/role-access.model';
import { AES } from 'crypto-js';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-product-request',
  templateUrl: './product-request.page.html',
  styleUrls: ['./product-request.page.scss'],
})
export class ProductRequestPage implements OnInit {

  page = {
    limit: 10,
    count: 0,
    offset: 0,
    orderBy: '',
    orderDir: 'desc'
  };

  rows: any;
  productRequestList: any;
  filteredData: any;
  token: any;
  userProfile: UserProfile = new UserProfile();
  counterId: any;
  statusId: any;
  counterList: any[] = [];
  docDateStart: any;
  docDateEnd: any;

  requestStatus = ProductRequestStatus;
  requestStatusList= Object.keys(ProductRequestStatus).filter(
    requestStatus => typeof this.requestStatus[requestStatus] === 'number'
  );

    requestStatusListWithSpace =  Object.keys(ProductRequestStatus)
      .filter(key => isNaN(Number(key))) // hanya ambil nama enum
      .forEach(key => {
        const value = ProductRequestStatus[key as keyof typeof ProductRequestStatus];
        this.requestStatusList[value] = this.addSpaceToCamelCase(key);
      });
  keywordSearch: any;
  
  userAccess: any[] = [];
  roleAccess = new RoleAccess();
  roleName: any;

  constructor(
    private storage: Storage,
    private navCtrl: NavController,
    private utilService: UtilService,
    private toastCtrl: ToastController,
    private userData: UserData,
    private modalController: ModalController,
    private router: Router,
    private requestService: ProductRequestService,
    private alertController: AlertController
  ) { }

  ngOnInit() {
  }

  ionViewDidEnter() {
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile, access]) => {
      if(token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        this.userAccess = access;
        this.roleName = this.userProfile.role_detail ? this.userProfile.role_detail.role_name : null;
        this.roleAccess = this.userData.checkAccess(this.router.url, this.userAccess, this.userProfile);
        if(!this.roleAccess || this.roleAccess.view!='1'){
          this.toastCtrl.create({ duration: 2000, message: 'You Are Not Allowed to Access this Page' }).then(t => t.present());
          this.navCtrl.navigateForward(['/']);
        }
        else{
          this.getDataForAdvancedFilter();
        }
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }

// Fungsi untuk tambah spasi sebelum huruf kapital
 addSpaceToCamelCase(text: string): string {
  return text.replace(/([a-z])([A-Z])/g, '$1 $2');
}
  getDataForAdvancedFilter() {
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let options = {
        "token": this.token,
        "counter_id": this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list,
      };

      this.requestService.getDataforAdvancedFilter(options)
      .subscribe((response) => {
        this.utilService.loadingDismiss();
        this.counterList = response.results.counter_data;

        this.pageCallback({ offset: this.page.offset });
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
        this.pageCallback({ offset: this.page.offset });
      });
    });
  }

  pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
    this.page.offset = pageInfo.offset;
    this.reloadTable();
  }
  
  sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.reloadTable();
  }

  reloadTable() {
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let offset = this.page.offset + 1;
      let counterIds: any;
      if(this.counterId) { counterIds = this.counterId; }
      else { counterIds = this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list; }

      let options = {
        "token": this.token,
        "page": offset.toString(),
        "counter_id": counterIds,
        "doc_date_start": this.docDateStart ? this.docDateStart : '2000-01-01',
        "doc_date_end": this.docDateEnd ? this.docDateEnd : '4712-12-31',
        "status_id": this.statusId !== undefined ? this.statusId : 'null',
        "keywords": this.keywordSearch ? this.keywordSearch : 'null'
      };
      this.requestService.getProductRequest(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        this.rows = response.results.data;
        this.filteredData = response.results.data;
        this.productRequestList = response.results.data;
      }, (err) => {
        this.utilService.loadingDismiss();
        console.log(err);
        if(err.error.error === 'token_expired') {
          this.userData.logout().then(() => {
            this.toastCtrl.create({ duration: 2000, message: 'Token telah expired. Silahkan login kembali' }).then(t => t.present());
            this.navCtrl.navigateForward(['/login']);
          });
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
        }
      });
    });
  }

  goToProductRequestCreate() {
    this.navCtrl.navigateForward(['/product-request/product-request-create']);
  }

  goToUpdatePage(id: any,actionType:any) {
    let myKey = environment.myKey;
    let encryptID = AES.encrypt(JSON.stringify(id),myKey).toString();
    let encryptAction = AES.encrypt(JSON.stringify(actionType),myKey).toString();
    let navigationExtras: NavigationExtras = {
      queryParams: {
        i: encryptID,
        a:encryptAction
      }
    };
    this.navCtrl.navigateForward(['/product-request/product-request-detail'], navigationExtras);
  }

  async openAdvancedFilters() {
    const modal = await this.modalController.create({
      component: ProductRequestComponent,
      componentProps: {
        counterList: this.counterList,
        counterId: this.counterId,
        docDateStart: this.docDateStart,
        docDateEnd: this.docDateEnd,
        statusId: this.statusId
      },
      backdropDismiss: false
    });

    modal.onDidDismiss().then((modelData) => {
      let data: any = modelData.data;

      if (data.length > 0) {
        this.keywordSearch = undefined;
        if(data[0].doc_date_start) {
          let convertDateStart = this.utilService.convertDate(data[0].doc_date_start);
          this.docDateStart = convertDateStart.years + '-' + convertDateStart.months + '-' + convertDateStart.dates;
        }
        if(data[0].doc_date_end) {
          let convertDateEnd = this.utilService.convertDate(data[0].doc_date_end);
          this.docDateEnd = convertDateEnd.years + '-' + convertDateEnd.months + '-' + convertDateEnd.dates;
        }
        
        this.counterId = data[0].counter_id;
        this.statusId = data[0].status_id;

        this.pageCallback({ offset: this.page.offset });
      }
    });

    return await modal.present();
  }

  filterDatatable(event) {
    let val = event.target.value.toLowerCase();
    let columnLength = 5;
    let keys = Object.keys(this.productRequestList[0]);
    this.rows = this.filteredData.filter(function(item){
      for (let i=0; i < columnLength; i++){
        if (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val){
          return true;
        }
      }
    });

    this.page.offset = 0;
  }

  checkStatus(status: any) {
    let cssClass: any = '';
    if(status === '0') { cssClass = 'status pending'}
    if(status === '1') { cssClass = 'status sent'}
    if(status === '2') { cssClass = 'status void'}
    if(status === '3') { cssClass = 'status void'}
    if(status === '4') { cssClass = 'status pending'}
    if(status === '5') { cssClass = 'status pending'}
    if(status === '6') { cssClass = 'status sent'}
    if(status === '7') { cssClass = 'status sent'}
    if(status === '7') { cssClass = 'status waiting'}
    return cssClass;
  }

  searchWithKeywords() {
    this.counterId = undefined;
    this.docDateStart = undefined;
    this.docDateEnd = undefined;
    this.statusId = undefined;

    this.pageCallback({ offset: this.page.offset });
  }

  clearFilters() {
    this.keywordSearch = undefined;
    this.counterId = undefined;
    this.docDateStart = undefined;
    this.docDateEnd = undefined;
    this.statusId = undefined;

    this.pageCallback({ offset: this.page.offset });
  }
  
  async showConfirmSend(id: any) {
    const alert = await this.alertController.create({
      header: 'Send Approval Confirmation',
      cssClass:'custom-alert-class',
      message: 'Apakah anda yakin untuk kirim PO ini ke cabang?',
      buttons: [
        {
          text: 'Tidak',
          handler: () => {}
        },
        {
          text: 'Ya',
          handler: () => {
            this.sendToBranch(id);
          }
        }
      ]
    });

    await alert.present();
  }
  
  sendToBranch(id: any) {
    let options = {
      "token": this.token,
      "id": id,
      "updated_by": this.userProfile.username,
      "level":0
    };
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      this.requestService.sendApprovalPo(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        if(response.status.code === 200) {
          this.reloadTable();
        } else {
          let errmsg = response.message ?response.message:'';
          this.toastCtrl.create({ duration: 2000, message: 'Terdapat Error  :'+errmsg }).then(t => t.present());
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }
  async cancelConfirmation(id: any) {
    const alert = await this.alertController.create({
      header: 'Confirmation',
      cssClass:'custom-alert-class',
      message: 'Apakah anda yakin untuk membatalkan PO ini?',
      buttons: [
        {
          text: 'Tidak',
          handler: () => {}
        },
        {
          text: 'Ya',
          handler: () => {
            this.showCancelReason(id);
          }
        }
      ]
    });
    await alert.present();
  }
   async showCancelReason(id: any) {
    const alert = await this.alertController.create({
      header: 'Confirmation',
      subHeader: 'Keterangan Cancel',
      message: 'Silahkan masukkan alasan pembatalan',
      inputs: [
        {
          name: 'cancelReason',
          placeholder: 'Alasan',
          type: 'text'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: () => {}
        },
        {
          text: 'OK',
          handler: (input: any) => {
            if(!input.cancelReason){
                this.showNotifNotAuthorized("Alasan pembatalan harus diisi");
            }
            else{
              let reason = input.cancelReason ? input.cancelReason : '-';
              this.saveCancelPO(id, reason);
            }
          }
        }
      ]
    });
    await alert.present();
  }
  async showNotifNotAuthorized(messageValue: any) {
    const alert = await this.alertController.create({
      header: 'Notification',
      cssClass:'custom-alert-class',
      message: messageValue,
      buttons: [
        {
          text: 'OK',
          handler: () => {}
        }
      ]
    });
    await alert.present();
  }
  saveCancelPO(id:any,reason:any){
    console.log("kirim API ke cabang buat cancel yg dicabang. id yg dicancel : "+id);
    let options = {
      "token": this.token,
      "id": id,
      "updated_by": this.userProfile.username,
      "reason": reason
    };
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      this.requestService.cancelPO(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        if(response.status.code === 200) {
          this.reloadTable();
        } else {
          let errmsg = response.message ?response.message:'';
          this.toastCtrl.create({ duration: 2000, message: 'Terdapat Error  :'+errmsg }).then(t => t.present());
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }
}
